import { ViewerRepartitionItem } from '../types/country-viewer-repartition.type';

export function groupViewerRepartition(data: ViewerRepartitionItem[]): ViewerRepartitionItem[] {
  if (data.length <= 10) return data;

  const visibleItems: ViewerRepartitionItem[] = data.slice(0, 10).map((item) => ({ ...item }));
  const hiddenViewersCount: number = data
    .slice(10)
    .reduce((total: number, item: ViewerRepartitionItem) => total + item.viewers_count, 0);
  const otherItem: ViewerRepartitionItem | undefined = visibleItems.find(
    (item: ViewerRepartitionItem) => item.cnt_id === null,
  );

  if (otherItem) {
    otherItem.viewers_count += hiddenViewersCount;
    return visibleItems;
  }

  return [...visibleItems, { cnt_id: null, viewers_count: hiddenViewersCount }];
}
